webpackJsonp([1],{

/***/ 142:
/*!****************************!*\
  !*** multi ./src/index.js ***!
  \****************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /Users/arve/git/webcas/src/index.js */143);


/***/ }),

/***/ 143:
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/*! exports provided:  */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(/*! ./App.vue */ 145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__polyfills_js__ = __webpack_require__(/*! ./polyfills.js */ 535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__polyfills_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__polyfills_js__);




new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({ // eslint-disable-line
  el: '#container',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  }
});

/***/ }),

/***/ 145:
/*!*********************!*\
  !*** ./src/App.vue ***!
  \*********************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_arve_git_webcas_node_modules_babel_preset_vue_app_dist_index_common_js_useBuiltIns_true_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/arve/git/webcas/node_modules/babel-preset-vue-app/dist/index.common.js",{"useBuiltIns":true}]]}!../node_modules/vue-loader/lib/selector?type=script&index=0!./App.vue */ 147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b0fc456_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-3b0fc456","hasScoped":false}!../node_modules/vue-loader/lib/selector?type=template&index=0!./App.vue */ 534);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-3b0fc456","scoped":false,"hasInlineConfig":true}!./style.css */ 146)
}
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 64)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_arve_git_webcas_node_modules_babel_preset_vue_app_dist_index_common_js_useBuiltIns_true_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b0fc456_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 146:
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3b0fc456","scoped":false,"hasInlineConfig":true}!./src/style.css ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 147:
/*!******************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/arve/git/webcas/node_modules/babel-preset-vue-app/dist/index.common.js",{"useBuiltIns":true}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mathjs__ = __webpack_require__(/*! mathjs */ 148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mathjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mathjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Modal_vue__ = __webpack_require__(/*! ./Modal.vue */ 527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StepInput_vue__ = __webpack_require__(/*! ./StepInput.vue */ 531);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var defaultState = {
      name: '',
      saveModal: false,
      openModal: false,
      noNameInput: false,
      saves: [],
      steps: [{ input: '', scope: {}, i: 0 }],
      focus: 0
    };
    var state = void 0;
    try {
      state = Object.assign(defaultState, JSON.parse(localStorage.getItem('default')));
    } catch (e) {}
    return state || defaultState;
  },
  computed: {
    outputs: function outputs() {
      var _this = this;

      return this.steps.map(function (step, i) {
        var prev = _this.steps[i - 1];
        step.scope = Object.assign({}, prev && prev.scope);
        return _this.evaluateInput(step);
      });
    }
  },
  components: {
    'modal': __WEBPACK_IMPORTED_MODULE_1__Modal_vue__["a" /* default */],
    'step-input': __WEBPACK_IMPORTED_MODULE_2__StepInput_vue__["a" /* default */]
  },
  methods: {
    addStep: function addStep(num) {
      var scope = num === 0 ? {} : Object.assign({}, this.steps[num - 1].scope);
      this.steps = [].concat(_toConsumableArray(this.steps.slice(0, num)), [{ scope: scope, i: num, input: '' }], _toConsumableArray(this.steps.slice(num)));
      this.steps.forEach(function (step, i) {
        return step.i = i;
      });
    },
    removeStep: function removeStep(num) {
      if (this.steps.length > 1) {
        this.steps = this.steps.filter(function (s, i) {
          return i !== num;
        });
        this.steps.forEach(function (step, i) {
          return step.i = i;
        });
      }
    },
    setFocus: function setFocus(num) {
      var l = this.steps.length;
      this.focus = (num + l) % l;
    },
    openSaveModal: function openSaveModal() {
      var _this2 = this;

      this.saveModal = true;
      setTimeout(function () {
        return _this2.$refs.saveNameInput.focus();
      }, 100);
    },
    erase: function erase() {
      if (confirm('This will delete all steps, are you sure?')) {
        this.steps = [{ input: '', scope: {}, i: 0 }];
        this.name = '';
        this.rerender();
      }
    },
    save: function save(saveName) {
      var _this3 = this;

      if (!saveName || saveName === '') {
        // bounce input field
        this.noNameInput = true;
        // remove animation class
        setTimeout(function () {
          return _this3.noNameInput = false;
        }, 1000);
        return;
      }
      this.saveModal = false;
      // prefix saves through UI with save:
      saveName = saveName === 'default' ? saveName : 'save:' + saveName;
      localStorage.setItem(saveName, JSON.stringify(this.$data));
      this.getSaves();
    },
    open: function open(saveName) {
      saveName = saveName === 'default' ? saveName : 'save:' + saveName;
      var savedState = JSON.parse(localStorage.getItem(saveName));
      for (var key in savedState) {
        if (key === 'steps' && savedState.steps.length && typeof savedState.steps[0] === 'string') {
          // steps are [''], convert to new format [{input: '', scope: {}, i: 0}]
          this[key] = savedState.steps.map(function (input, i) {
            return { input: input, i: i, scope: {} };
          });
        } else {
          this[key] = savedState[key];
        }
      }
      this.openModal = false;
      this.getSaves();
      this.rerender();
    },
    getSaves: function getSaves() {
      this.saves = Object.keys(localStorage).filter(function (s) {
        return s.match(/^save:/);
      }).map(function (s) {
        return s.replace('save:', '');
      });
    },
    removeSave: function removeSave(saveName) {
      if (confirm('Delete "' + saveName + '"?')) {
        localStorage.removeItem('save:' + saveName);
        this.saves = this.saves.filter(function (s) {
          return s !== saveName;
        });
      }
    },
    rerender: function rerender() {
      var steps = this.steps;
      this.steps = [];
      // force rerender of all inputs
      this.$nextTick(function () {
        this.steps = steps;
      });
    },
    keydown: function keydown(event) {
      this.$nextTick(function () {
        if (!this.saveModal) {
          this.save('default');
        }
      });
      if (!event.ctrlKey && !event.metaKey) {
        return;
      }
      if (event.keyCode === 83) {
        // 83 s -> save
        event.preventDefault();
        if (this.saveModal) {
          this.save(this.name);
        } else {
          this.openSaveModal();
        }
      } else if (event.keyCode === 79) {
        // 79 o -> open
        event.preventDefault();
        this.openModal = true;
      }
    },
    evaluateInput: function evaluateInput(_ref) {
      var input = _ref.input,
          scope = _ref.scope;

      var precision = 15;

      var node = void 0,
          evaluated = void 0,
          output = void 0;
      try {
        node = __WEBPACK_IMPORTED_MODULE_0_mathjs___default.a.parse(input);
        try {
          evaluated = node.eval(scope);
        } catch (err) {
          evaluated = __WEBPACK_IMPORTED_MODULE_0_mathjs___default.a.simplify(node);
        }
      } catch (err) {
        evaluated = err.message;
      }
      scope._ = evaluated !== undefined ? evaluated : '';

      switch (typeof evaluated === 'undefined' ? 'undefined' : _typeof(evaluated)) {
        case 'object':
          output = evaluated.format ? evaluated.format(precision) : evaluated.toString();
          break;

        case 'number':
          output = __WEBPACK_IMPORTED_MODULE_0_mathjs___default.a.format(evaluated, precision);
          break;

        case 'function':
          output = node.toString();
          break;

        case 'boolean':
          output = evaluated.toString();
          break;

        default:
          // error in input? set output empty
          output = evaluated || '';
          break;
      }
      return output;
    }
  },
  mounted: function mounted() {
    window.addEventListener('keydown', this.keydown);
    this.getSaves();
  },
  destroyed: function destroyed() {
    window.removeEventListener('keydown', this.keydown);
  }
});

/***/ }),

/***/ 527:
/*!***********************!*\
  !*** ./src/Modal.vue ***!
  \***********************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_arve_git_webcas_node_modules_babel_preset_vue_app_dist_index_common_js_useBuiltIns_true_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/arve/git/webcas/node_modules/babel-preset-vue-app/dist/index.common.js",{"useBuiltIns":true}]]}!../node_modules/vue-loader/lib/selector?type=script&index=0!./Modal.vue */ 529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d138ba2_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-1d138ba2","hasScoped":true}!../node_modules/vue-loader/lib/selector?type=template&index=0!./Modal.vue */ 530);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-1d138ba2","scoped":true,"hasInlineConfig":true}!../node_modules/vue-loader/lib/selector?type=styles&index=0!./Modal.vue */ 528)
}
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 64)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1d138ba2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_arve_git_webcas_node_modules_babel_preset_vue_app_dist_index_common_js_useBuiltIns_true_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d138ba2_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 528:
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1d138ba2","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Modal.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 529:
/*!********************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/arve/git/webcas/node_modules/babel-preset-vue-app/dist/index.common.js",{"useBuiltIns":true}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Modal.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    keyup: function keyup(event) {
      // 13 enter
      if (event.keyCode === 13) {
        this.$emit('button');
      }
      // 27 esc
      if (event.keyCode === 27) {
        this.$emit('close');
      }
    }
  },
  mounted: function mounted() {
    window.addEventListener('keyup', this.keyup);
  },
  destroyed: function destroyed() {
    window.removeEventListener('keyup', this.keyup);
  }
});

/***/ }),

/***/ 530:
/*!*********************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d138ba2","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Modal.vue ***!
  \*********************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.$emit('close')}}},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_c('h1',[_vm._t("title",[_vm._v("\n              default title\n            ")])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("body",[_vm._v("\n            default body\n          ")])],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"modal-button",on:{"click":function($event){_vm.$emit('button')}}},[_vm._t("button",[_vm._v("\n              Close\n            ")])],2)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 531:
/*!***************************!*\
  !*** ./src/StepInput.vue ***!
  \***************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_arve_git_webcas_node_modules_babel_preset_vue_app_dist_index_common_js_useBuiltIns_true_node_modules_vue_loader_lib_selector_type_script_index_0_StepInput_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/arve/git/webcas/node_modules/babel-preset-vue-app/dist/index.common.js",{"useBuiltIns":true}]]}!../node_modules/vue-loader/lib/selector?type=script&index=0!./StepInput.vue */ 532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24725a53_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_StepInput_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-24725a53","hasScoped":false}!../node_modules/vue-loader/lib/selector?type=template&index=0!./StepInput.vue */ 533);
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 64)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_arve_git_webcas_node_modules_babel_preset_vue_app_dist_index_common_js_useBuiltIns_true_node_modules_vue_loader_lib_selector_type_script_index_0_StepInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24725a53_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_StepInput_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 532:
/*!************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/arve/git/webcas/node_modules/babel-preset-vue-app/dist/index.common.js",{"useBuiltIns":true}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/StepInput.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['value', 'i', 'last', 'focus', 'setFocus'],
  data: function data() {
    return {
      input: this.value,
      empty: false
    };
  },
  directives: {
    focus: function focus(el, binding) {
      // <element v-focus="true"> will focus element
      if (binding.value) {
        el.focus();
      }
    }
  },
  mounted: function mounted() {
    if (this.focus) {
      this.$refs.input.focus();
    }
  },
  methods: {
    addStep: function addStep(event) {
      if (event.target.selectionStart === 0) {
        // enter and marker in beginning of input field
        // -> insert new input and shift rest of steps down
        this.$emit('add', this.i);
      } else if (this.last) {
        // add step at bottom, increment focus
        this.$emit('add', this.i + 1);
        this.$emit('focus', this.i + 1);
      } else {
        // enter on input in the middle
        this.$emit('focus', this.i + 1);
      }
    },
    removeStep: function removeStep(event) {
      if (!this.empty && this.input === '') {
        this.empty = true;
      } else if (this.empty) {
        this.$emit('remove', this.i);
        if (event.keyCode !== 46 || this.last) {
          // backspace key or in end
          // delete key keeps focus on same input
          this.$emit('focus', this.i - 1);
        }
      }
    }
  }
});

/***/ }),

/***/ 533:
/*!**************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24725a53","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/StepInput.vue ***!
  \**************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("Input\n  "),_c('input',{directives:[{name:"focus",rawName:"v-focus",value:(_vm.focus),expression:"focus"},{name:"model",rawName:"v-model",value:(_vm.input),expression:"input"}],ref:"input",attrs:{"type":"text"},domProps:{"value":(_vm.input)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.input=$event.target.value},function($event){_vm.$emit('input', $event.target.value)}],"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13)){ return null; }$event.preventDefault();_vm.addStep($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"tab",9)){ return null; }$event.preventDefault();_vm.setFocus(_vm.i + 1)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40)){ return null; }$event.preventDefault();_vm.setFocus(_vm.i + 1)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"tab",9)){ return null; }if(!$event.shiftKey){ return null; }$event.preventDefault();_vm.setFocus(_vm.i - 1)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38)&&_vm._k($event.keyCode,"tab",9)){ return null; }$event.preventDefault();_vm.setFocus(_vm.i - 1)}],"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"delete",[8,46])){ return null; }_vm.removeStep($event)},"click":function($event){_vm.setFocus(_vm.i)}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 534:
/*!********************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b0fc456","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue ***!
  \********************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("WebCAS")]),_vm._v(" "),_c('div',{attrs:{"id":"menu"}},[_c('button',{on:{"click":_vm.erase}},[_c('img',{attrs:{"src":"file.svg"}}),_vm._v(" New")]),_vm._v(" "),_c('button',{on:{"click":_vm.openSaveModal}},[_c('img',{attrs:{"src":"save.svg"}}),_vm._v(" Save")]),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.openModal = true}}},[_c('img',{attrs:{"src":"folder.svg"}}),_vm._v(" Open")])]),_vm._v(" "),_c('div',{staticClass:"steps"},_vm._l((_vm.steps),function(step,i){return _c('div',{key:step.i,staticClass:"step"},[_c('step-input',{attrs:{"i":step.i,"focus":i === _vm.focus && !_vm.saveModal,"last":step.i === (_vm.steps.length - 1),"setFocus":_vm.setFocus},on:{"add":_vm.addStep,"remove":_vm.removeStep,"focus":_vm.setFocus},model:{value:(step.input),callback:function ($$v) {step.input=$$v},expression:"step.input"}}),_vm._v(" "),_c('div',{staticClass:"output"},[_vm._v("Output "),_c('span',[_vm._v(_vm._s(_vm.outputs[step.i]))])])],1)})),_vm._v(" "),(_vm.saveModal)?_c('modal',{on:{"close":function($event){_vm.saveModal = false},"button":function($event){_vm.save(_vm.name)}}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Save")]),_vm._v(" "),_c('span',{attrs:{"slot":"body"},slot:"body"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],ref:"saveNameInput",class:{ bounce: _vm.noNameInput },attrs:{"placeholder":"Input a name","type":"text"},domProps:{"value":(_vm.name)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13)){ return null; }_vm.save(_vm.name)},"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})]),_vm._v(" "),_c('span',{attrs:{"slot":"button"},slot:"button"},[_vm._v("Save")])]):_vm._e(),_vm._v(" "),(_vm.openModal)?_c('modal',{on:{"close":function($event){_vm.openModal = false},"button":function($event){_vm.openModal = false}}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Open")]),_vm._v(" "),_c('span',{attrs:{"slot":"body"},slot:"body"},[(_vm.saves.length === 0)?_c('p',[_vm._v("No saves found.")]):_vm._e(),_vm._v(" "),_c('ul',{staticClass:"openList"},_vm._l((_vm.saves),function(save){return _c('li',{on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.open(save)}}},[_vm._v("\n          "+_vm._s(save)+"\n          "),_c('img',{attrs:{"src":"x.svg","title":"Delete"},on:{"click":function($event){_vm.removeSave(save)}}})])}))])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 535:
/*!**************************!*\
  !*** ./src/polyfills.js ***!
  \**************************/
/*! no static exports found */
/***/ (function(module, exports) {

if (typeof Object.assign !== 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target, varArgs) {
      // .length of function is 2
      'use strict';

      if (target == null) {
        // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      var to = Object(target);

      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (nextSource != null) {
          // Skip over if undefined or null
          for (var nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}

/***/ })

},[142]);


// WEBPACK FOOTER //
// client.e66ad672.js